var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.3688 0.151239C53.8944 1.08674 68.3114 10.5045 62.5915 20.6404C59.7484 25.6786 53.3749 28.0456 50.4673 33.0826C49.5511 34.6696 49.3563 36.7649 50.2981 38.3366C51.5328 40.3969 54.2803 40.9496 56.013 42.6129C59.0876 45.5642 57.9254 51.2924 54.5029 53.8322C47.125 59.3076 36.137 59.4024 27.2201 58.6566C17.7071 57.861 15.0844 57.6995 7.15827 63.124C4.04914 65.2519 -0.39198 63.3304 0.150895 59.2262C0.982895 52.9367 5.84089 48.1645 10.9991 44.4702C15.8151 41.0211 35.4613 35.9086 30.8259 29.5235C28.1586 25.8494 22.8994 24.8482 19.1298 22.1925C16.5919 20.4045 16.0775 18.3375 16.7314 14.9477C18.1939 7.36599 30.0901 -1.25114 44.3688 0.151239Z",
    fill: "url(#paint0_linear_3648_147713)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.68534 22.1559H6.70784V17.082C6.70784 16.7368 6.42809 16.457 6.08284 16.457C5.73759 16.457 5.45784 16.7368 5.45784 17.082V22.1559H4.48047C4.13534 22.1559 3.85547 22.4358 3.85547 22.7809V34.2333C3.85547 34.5784 4.13534 34.8583 4.48047 34.8583H5.45784V39.4322C5.45784 39.7774 5.73759 40.0572 6.08284 40.0572C6.42809 40.0572 6.70784 39.7774 6.70784 39.4322V34.8583H7.68534C8.03047 34.8583 8.31034 34.5784 8.31034 34.2333V22.7809C8.31034 22.4357 8.03047 22.1559 7.68534 22.1559Z",
    fill: "#3FC0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2891 22.6511H20.2664V32.225C20.2664 32.5703 20.5462 32.85 20.8914 32.85C21.2367 32.85 21.5164 32.5703 21.5164 32.225V22.6511H22.4939C22.8391 22.6511 23.1189 22.3712 23.1189 22.0261V18.0738C23.1189 17.7286 22.8391 17.4488 22.4939 17.4488H21.5164V9.875C21.5164 9.52975 21.2367 9.25 20.8914 9.25C20.5462 9.25 20.2664 9.52975 20.2664 9.875V17.4488H19.2891C18.9439 17.4488 18.6641 17.7286 18.6641 18.0738V22.0261C18.6641 22.3714 18.9438 22.6511 19.2891 22.6511Z",
    fill: "#3FC0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5174 44.1349H58.54V37.811C58.54 37.4658 58.2603 37.186 57.915 37.186C57.5698 37.186 57.29 37.4658 57.29 37.811V44.1349H56.3125C55.9674 44.1349 55.6875 44.4148 55.6875 44.7599V53.7123C55.6875 54.0574 55.9674 54.3373 56.3125 54.3373H57.29V60.161C57.29 60.5063 57.5698 60.786 57.915 60.786C58.2603 60.786 58.54 60.5063 58.54 60.161V54.3373H59.5174C59.8625 54.3373 60.1424 54.0574 60.1424 53.7123V44.7599C60.1424 44.4147 59.8625 44.1349 59.5174 44.1349Z",
    fill: "#3FC0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.115 45.2974H51.1377V30.2236C51.1377 29.8784 50.8579 29.5986 50.5127 29.5986C50.1674 29.5986 49.8877 29.8784 49.8877 30.2236V45.2974H48.9102C48.565 45.2974 48.2852 45.5773 48.2852 45.9224V49.8748C48.2852 50.2199 48.565 50.4998 48.9102 50.4998H49.8877V52.5736C49.8877 52.9189 50.1674 53.1986 50.5127 53.1986C50.8579 53.1986 51.1377 52.9189 51.1377 52.5736V50.4998H52.115C52.4602 50.4998 52.74 50.2199 52.74 49.8748V45.9224C52.74 45.5773 52.4602 45.2974 52.115 45.2974Z",
    fill: "#3FC0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9213 18.5671C49.3763 19.0208 50.1551 18.7308 50.2001 18.0896L50.6851 11.2183C50.7176 10.7633 50.3388 10.3858 49.8838 10.4183L43.0138 10.9033C42.3726 10.9483 42.0813 11.7271 42.5363 12.1808L43.9613 13.6058L39.8315 17.7357V8.11084C39.8315 7.42046 39.2718 6.86084 38.5815 6.86084H27.5271C26.8367 6.86084 26.2771 7.42046 26.2771 8.11084V18.5821C26.2771 19.2725 26.8367 19.8321 27.5271 19.8321H27.6733V22.8353H26.696C26.3508 22.8353 26.071 23.1152 26.071 23.4603V37.4127C26.071 37.7578 26.3508 38.0377 26.696 38.0377H27.6733V40.1115C27.6733 40.4567 27.9531 40.7365 28.2983 40.7365C28.6436 40.7365 28.9233 40.4567 28.9233 40.1115V38.0377H29.9008C30.246 38.0377 30.5258 37.7578 30.5258 37.4127V33.4116L34.8623 37.7473L26.6003 46.0093C24.9815 44.6896 22.9156 43.8972 20.6641 43.8972C18.1166 43.8972 15.8073 44.912 14.1141 46.5572V42.6606H15.0916C15.4367 42.6606 15.7166 42.3807 15.7166 42.0356V33.0832C15.7166 32.7381 15.4367 32.4582 15.0916 32.4582H14.1141V24.9543C14.1141 24.6091 13.8343 24.3293 13.4891 24.3293C13.1438 24.3293 12.8641 24.6091 12.8641 24.9543V32.4582H11.8867C11.5416 32.4582 11.2617 32.7381 11.2617 33.0832V42.0356C11.2617 42.3807 11.5416 42.6606 11.8867 42.6606H12.8641V47.8043C12.8641 47.873 12.8778 47.9377 12.8982 47.9995C11.8662 49.5086 11.2617 51.3333 11.2617 53.2996C11.2617 58.4925 15.4713 62.702 20.6641 62.702C25.8568 62.702 30.0665 58.4923 30.0665 53.2996C30.0665 52.1947 29.8743 51.1351 29.5242 50.1502L40.8803 38.7832V46.7755C40.8803 47.1206 41.1602 47.4005 41.5053 47.4005H42.4828V49.4743C42.4828 49.8196 42.7626 50.0993 43.1078 50.0993C43.4531 50.0993 43.7328 49.8196 43.7328 49.4743V47.4005H44.7102C45.0553 47.4005 45.3352 47.1206 45.3352 46.7755V35.3231C45.3352 34.978 45.0553 34.6981 44.7102 34.6981H43.7328V27.1243C43.7328 26.7791 43.4531 26.4993 43.1078 26.4993C42.7626 26.4993 42.4828 26.7791 42.4828 27.1243V34.6981H41.5053C41.1602 34.6981 40.8803 34.978 40.8803 35.3231V36.6951L37.9305 33.7447V26.8917C37.9305 26.8358 37.9208 26.7828 37.9071 26.7313L47.4963 17.1421L48.9213 18.5671ZM30.5258 27.0413V23.4603C30.5258 23.1152 30.246 22.8353 29.9008 22.8353H28.9233V19.8321H37.7351L30.5258 27.0413Z",
    fill: "#3FC0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6997 55.3384H33.0508C32.7055 55.3384 32.4258 55.6181 32.4258 55.9634C32.4258 56.3086 32.7055 56.5884 33.0508 56.5884H35.6997C36.0449 56.5884 36.3247 56.3086 36.3247 55.9634C36.3247 55.6181 36.0449 55.3384 35.6997 55.3384Z",
    fill: "#3FC0FF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.08203 14.082V36.932",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68534 31.8581H4.48047C4.13534 31.8581 3.85547 31.5783 3.85547 31.2331V19.7808C3.85547 19.4356 4.13534 19.1558 4.48047 19.1558H7.68534C8.03047 19.1558 8.31034 19.4356 8.31034 19.7808V31.2331C8.31034 31.5783 8.03047 31.8581 7.68534 31.8581Z",
    fill: "#B4DDF1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68534 31.8581H4.48047C4.13534 31.8581 3.85547 31.5783 3.85547 31.2331V19.7808C3.85547 19.4356 4.13534 19.1558 4.48047 19.1558H7.68534C8.03047 19.1558 8.31034 19.4356 8.31034 19.7808V31.2331C8.31034 31.5783 8.03047 31.8581 7.68534 31.8581Z",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4883 21.9546V44.8046",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0916 39.6609H11.8867C11.5416 39.6609 11.2617 39.381 11.2617 39.0359V30.0835C11.2617 29.7384 11.5416 29.4585 11.8867 29.4585H15.0916C15.4367 29.4585 15.7166 29.7384 15.7166 30.0835V39.0359C15.7166 39.3811 15.4367 39.6609 15.0916 39.6609Z",
    fill: "#B4DDF1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0916 39.6609H11.8867C11.5416 39.6609 11.2617 39.381 11.2617 39.0359V30.0835C11.2617 29.7384 11.5416 29.4585 11.8867 29.4585H15.0916C15.4367 29.4585 15.7166 29.7384 15.7166 30.0835V39.0359C15.7166 39.3811 15.4367 39.6609 15.0916 39.6609Z",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8906 6.875V29.7251",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4939 19.6511H19.2891C18.9439 19.6511 18.6641 19.3712 18.6641 19.0261V15.0737C18.6641 14.7286 18.9439 14.4487 19.2891 14.4487H22.4939C22.8391 14.4487 23.1189 14.7286 23.1189 15.0737V19.0261C23.1189 19.3714 22.8392 19.6511 22.4939 19.6511Z",
    fill: "#B4DDF1"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4939 19.6511H19.2891C18.9439 19.6511 18.6641 19.3712 18.6641 19.0261V15.0737C18.6641 14.7286 18.9439 14.4487 19.2891 14.4487H22.4939C22.8391 14.4487 23.1189 14.7286 23.1189 15.0737V19.0261C23.1189 19.3714 22.8392 19.6511 22.4939 19.6511Z",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9141 34.8115V57.6615",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3125 51.3376H59.5174C59.8625 51.3376 60.1424 51.0578 60.1424 50.7126V41.7603C60.1424 41.4151 59.8625 41.1353 59.5174 41.1353H56.3125C55.9674 41.1353 55.6875 41.4151 55.6875 41.7603V50.7126C55.6875 51.0578 55.9674 51.3376 56.3125 51.3376Z",
    fill: "#B4DDF1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3125 51.3376H59.5174C59.8625 51.3376 60.1424 51.0578 60.1424 50.7126V41.7603C60.1424 41.4151 59.8625 41.1353 59.5174 41.1353H56.3125C55.9674 41.1353 55.6875 41.4151 55.6875 41.7603V50.7126C55.6875 51.0578 55.9674 51.3376 56.3125 51.3376Z",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5117 27.2236V50.0738",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9102 47.4997H52.115C52.4602 47.4997 52.74 47.2199 52.74 46.8747V42.9224C52.74 42.5772 52.4602 42.2974 52.115 42.2974H48.9102C48.565 42.2974 48.2852 42.5772 48.2852 42.9224V46.8747C48.2852 47.22 48.565 47.4997 48.9102 47.4997Z",
    fill: "#B4DDF1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9102 47.4997H52.115C52.4602 47.4997 52.74 47.2199 52.74 46.8747V42.9224C52.74 42.5772 52.4602 42.2974 52.115 42.2974H48.9102C48.565 42.2974 48.2852 42.5772 48.2852 42.9224V46.8747C48.2852 47.22 48.565 47.4997 48.9102 47.4997Z",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1055 24.1245V46.9746",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5039 44.4006H44.7088C45.0539 44.4006 45.3338 44.1207 45.3338 43.7756V32.3232C45.3338 31.9781 45.0539 31.6982 44.7088 31.6982H41.5039C41.1588 31.6982 40.8789 31.9781 40.8789 32.3232V43.7756C40.8789 44.1209 41.1587 44.4006 41.5039 44.4006Z",
    fill: "#B4DDF1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5039 44.4006H44.7088C45.0539 44.4006 45.3338 44.1207 45.3338 43.7756V32.3232C45.3338 31.9781 45.0539 31.6982 44.7088 31.6982H41.5039C41.1588 31.6982 40.8789 31.9781 40.8789 32.3232V43.7756C40.8789 44.1209 41.1587 44.4006 41.5039 44.4006Z",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6992 20.6934V34.0434",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0977 31.4695H37.3025C37.6477 31.4695 37.9275 31.1896 37.9275 30.8445V23.8921C37.9275 23.547 37.6477 23.2671 37.3025 23.2671H34.0977C33.7525 23.2671 33.4727 23.547 33.4727 23.8921V30.8445C33.4727 31.1896 33.7525 31.4695 34.0977 31.4695Z",
    fill: "#B4DDF1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0977 31.4695H37.3025C37.6477 31.4695 37.9275 31.1896 37.9275 30.8445V23.8921C37.9275 23.547 37.6477 23.2671 37.3025 23.2671H34.0977C33.7525 23.2671 33.4727 23.547 33.4727 23.8921V30.8445C33.4727 31.1896 33.7525 31.4695 34.0977 31.4695Z",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2969 16.832V37.6115",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6953 35.0378H29.9002C30.2453 35.0378 30.5252 34.7579 30.5252 34.4128V20.4604C30.5252 20.1153 30.2453 19.8354 29.9002 19.8354H26.6953C26.3502 19.8354 26.0703 20.1153 26.0703 20.4604V34.4128C26.0703 34.7581 26.3502 35.0378 26.6953 35.0378Z",
    fill: "#B4DDF1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6953 35.0378H29.9002C30.2453 35.0378 30.5252 34.7579 30.5252 34.4128V20.4604C30.5252 20.1153 30.2453 19.8354 29.9002 19.8354H26.6953C26.3502 19.8354 26.0703 20.1153 26.0703 20.4604V34.4128C26.0703 34.7581 26.3502 35.0378 26.6953 35.0378Z",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6869 8.21846L50.2019 15.0897C50.1569 15.731 49.3781 16.021 48.9231 15.5672L47.4981 14.1422L34.4142 27.2261L41.0417 33.8548C41.5305 34.3423 41.5305 35.1336 41.043 35.6223L25.4443 51.2361L22.7188 46.8928L34.8643 34.7473L28.2267 28.1111C27.7392 27.6223 27.7392 26.8311 28.2267 26.3423L43.9632 10.606L42.5382 9.18096C42.0833 8.72721 42.3745 7.94846 43.0158 7.90346L49.8857 7.41846C50.3406 7.38596 50.7194 7.76346 50.6869 8.21846Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1521 44.5217L41.043 35.6223C41.5305 35.1336 41.5305 34.3423 41.0417 33.8548L34.4142 27.2261L47.4981 14.1422L48.9231 15.5672C49.3781 16.021 50.1569 15.731 50.2019 15.0897L50.6869 8.21846C50.7194 7.76346 50.3406 7.38596 49.8856 7.41846L43.0156 7.90346C42.3744 7.94846 42.0831 8.72721 42.5381 9.18096L43.9631 10.606L28.2267 26.3423C27.7392 26.8311 27.7392 27.6223 28.2267 28.1111L34.8643 34.7473L22.7188 46.8928",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6641 59.7022C25.8569 59.7022 30.0665 55.4926 30.0665 50.2998C30.0665 45.107 25.8569 40.8975 20.6641 40.8975C15.4713 40.8975 11.2617 45.107 11.2617 50.2998C11.2617 55.4926 15.4713 59.7022 20.6641 59.7022Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6632 57.7873C24.7983 57.7873 28.1505 54.435 28.1505 50.2999C28.1505 46.1647 24.7983 42.8125 20.6632 42.8125C16.528 42.8125 13.1758 46.1647 13.1758 50.2999C13.1758 54.435 16.528 57.7873 20.6632 57.7873Z",
    fill: "#B4DDF1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6636 56.4829C24.0784 56.4829 26.8467 53.7147 26.8467 50.2998C26.8467 46.885 24.0784 44.1167 20.6636 44.1167C17.2487 44.1167 14.4805 46.885 14.4805 50.2998C14.4805 53.7147 17.2487 56.4829 20.6636 56.4829Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6641 59.7022C25.8569 59.7022 30.0665 55.4926 30.0665 50.2998C30.0665 45.107 25.8569 40.8975 20.6641 40.8975C15.4713 40.8975 11.2617 45.107 11.2617 50.2998C11.2617 55.4926 15.4713 59.7022 20.6641 59.7022Z",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M22.216 48.2114H19.9614C19.4932 48.2114 19.1134 48.5911 19.1134 49.0594C19.1134 49.3946 19.3108 49.6982 19.6169 49.8343L21.7124 50.7657C22.0187 50.9018 22.2159 51.2054 22.2159 51.5406C22.2159 52.0088 21.8363 52.3885 21.3679 52.3885H19.1133",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6641 48.2114V46.9575",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6641 53.6421V52.3882",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0508 53.4634H35.6997",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0508 51.2363H35.6997",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0508 49.0088H34.3752",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5817 16.8321H27.5273C26.837 16.8321 26.2773 16.2725 26.2773 15.5821V5.11084C26.2773 4.42047 26.837 3.86084 27.5273 3.86084H38.5817C39.2721 3.86084 39.8317 4.42047 39.8317 5.11084V15.5821C39.8317 16.2725 39.2721 16.8321 38.5817 16.8321Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8317 7.20509V5.11084C39.8317 4.42047 39.2721 3.86084 38.5817 3.86084H27.5273C26.837 3.86084 26.2773 4.42047 26.2773 5.11084V7.20521L39.8317 7.20509Z",
    fill: "#B4DDF1"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2773 12.8127V15.5821C26.2773 16.2725 26.837 16.8321 27.5273 16.8321H38.5817C39.2721 16.8321 39.8317 16.2725 39.8317 15.5821V5.11084C39.8317 4.42047 39.2721 3.86084 38.5817 3.86084H27.5273C26.837 3.86084 26.2773 4.42047 26.2773 5.11084V9.00622",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9492 9.16211H29.3857",
    stroke: "#B4DDF1",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M31.543 9.16211H31.9795",
    stroke: "#B4DDF1",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1328 9.16211H34.5693",
    stroke: "#B4DDF1",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7266 9.16211H37.1632",
    stroke: "#B4DDF1",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9492 11.5698H29.3857",
    stroke: "#B4DDF1",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M31.543 11.5698H31.9795",
    stroke: "#B4DDF1",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M31.918 14.228H37.3936L36.1825 13.1143",
    stroke: "#B4DDF1",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9283 19.1621C51.9283 19.9445 51.2941 20.5787 50.5117 20.5787C51.2941 20.5787 51.9283 21.213 51.9283 21.9954C51.9283 21.213 52.5626 20.5787 53.345 20.5787C52.5626 20.5787 51.9283 19.9445 51.9283 19.1621Z",
    stroke: "#B4DDF1",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16272 43.4814C7.16272 44.2638 6.52847 44.8981 5.74609 44.8981C6.52847 44.8981 7.16272 45.5323 7.16272 46.3147C7.16272 45.5323 7.79697 44.8981 8.57934 44.8981C7.79697 44.8982 7.16272 44.2639 7.16272 43.4814Z",
    stroke: "#B4DDF1",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8125 14.2334L55.6875 13.1084L54.5625 14.2334",
    stroke: "#B4DDF1",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1953 55.3232L42.0703 54.1982L40.9453 55.3232",
    stroke: "#B4DDF1",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9258 10.9092L12.8008 9.78418L11.6758 10.9092",
    stroke: "#B4DDF1",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3648_147713",
    x1: 3.55012,
    y1: 65.0659,
    x2: 60.4479,
    y2: 8.16807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0DCFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5C3FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrading);
export default __webpack_public_path__ + "static/media/trading.e4c8f95e5b7d2d9d8f845a9c5f232767.svg";
export { ForwardRef as ReactComponent };